import i18n from "../../i18n";
import {
  SIGNUP_REQUESTING,
  SIGNUP_ERROR,
  SIGNUP_SUCCESS,
  SIGNUP_INPUT_CHANGE,
  SIGNUP_PROGRESS_CHANGE,
  SIGNUP_STATS_CHANGE,
  SIGNUP_CHOICE_ADD,
  SIGNUP_CHOICE_REMOVE,
  SIGNUP_ONBOARDING_END_REQUESTING,
  SIGNUP_PROGRESS_CHANGE_RATIO,
  SIGNUP_CLICK_TOPIC,
  GET_CLIENT_REQUESTING,
  GET_CLIENT_SUCCESS,
  GET_CLIENT_ERROR,
  CHECK_MAGIC_CODE_REQUESTING,
  CHECK_MAGIC_CODE_ERROR,
  CHECK_MAGIC_CODE_SUCCESS,
  SIGNUP_SURVEY_SET_STATS,
} from "./constants";
import { LOGOUT } from "../login/constants";
import { ISignUpReducer } from "./types";

const initialState: ISignUpReducer = {
  userClient: {},
  clientName: "Microdoing",
  signupPolicy: "",
  goalNumber: 3,
  requesting: false,
  successful: false,
  messages: [""],
  progress: 0,
  progressRatio: 1 / 6,
  errors: {
    global: "",
    name: "",
    email: "",
    password: "",
  },
  firstName: "",
  lastName: "",
  email: "",
  sex: "", // M / Mme / Mlle
  password: "",
  accessCode: "",
  fullName: "",
  birthDate: "",
  jobFunction: "",
  manager: "", // boolean - but need an initialstate for empty state
  stats: {
    teamCohesion: 5,
    leadership: 5,
    confidence: 5,
    stress: 5,
    publicSpeaking: 5,
  },
  userTopicChoices: [],
  topicOptions: [
    {
      title: {
        fr: "Développer sa confiance en soi",
        en: "Develop self-confidence",
      },
      value: "signup-topic-1",
    },
    {
      title: {
        fr: "Développer une posture de manager coach",
        en: "Develop a managerial coach posture",
      },
      value: "signup-topic-2",
    },
    {
      title: {
        fr: "Mieux fédérer et motiver ses équipes",
        en: "Better federate and motivate teams",
      },
      value: "signup-topic-3",
    },
    {
      title: {
        fr: "Prendre davantage de recul et lâcher prise",
        en: "Take a step back and learn to let go",
      },
      value: "signup-topic-4",
    },
    {
      title: {
        fr: "Mieux gérer son stress et ses émotions",
        en: "Better manage stress and emotions",
      },
      value: "signup-topic-5",
    },
    {
      title: {
        fr:
          "Améliorer ses performances et entrer dans un processus d’amélioration continue",
        en:
          "Improve its performance and enter into a process of continuous improvement",
      },
      value: "signup-topic-6",
    },
    {
      title: {
        fr: "Être plus à l’aise et impactant lors d’une présentation",
        en: "Be more comfortable and impactful during a presentation",
      },
      value: "signup-topic-7",
    },
    {
      title: {
        fr: "Mieux s’organiser et se dégager du temps",
        en: "Better organize and free yourself some time out",
      },
      value: "signup-topic-8",
    },
    {
      title: {
        fr: "Développer un optimisme à toute épreuve",
        en: "Develop a strong optimism",
      },
      value: "signup-topic-9",
    },
    {
      title: {
        fr: "Développer ses compétences relationnelles",
        en: "Develop interpersonal skills",
      },
      value: "signup-topic-10",
    },
    {
      title: {
        fr: "Développer son réseau",
        en: "Develop your network",
      },
      value: "signup-topic-11",
    },
    {
      title: {
        fr: "Développer son charisme",
        en: "Develop your charisma",
      },
      value: "signup-topic-12",
    },
    {
      title: {
        fr: "Développer sa créativité et sa capacité à trouver des solutions",
        en: "Develop creativity and the ability to find solutions",
      },
      value: "signup-topic-13",
    },
    {
      title: {
        fr: "Maitriser l’art du feedback",
        en: "Master the art of feedback",
      },
      value: "signup-topic-14",
    },
  ],
  choice: [],
  choiceAvailable: [
    {
      name: i18n.t("leadership"),
      description: i18n.t("leadership-description"),
      value: "leadership",
    },
    {
      name: i18n.t("proactivity"),
      description: i18n.t("proactivity-description"),
      value: "proactivity",
    },
    {
      name: i18n.t("resilience"),
      description: i18n.t("resilience-description"),
      value: "resilience",
    },
    {
      name: i18n.t("teamCohesion"),
      description: i18n.t("teamCohesion-description"),
      value: "teamCohesion",
    },
    {
      name: i18n.t("publicSpeaking"),
      description: i18n.t("publicSpeaking-description"),
      value: "publicSpeaking",
    },
  ],
  error: "",
};

const reducer = function signupReducer(
  state: ISignUpReducer = initialState,
  action,
): ISignUpReducer {
  switch (action.type) {
    case CHECK_MAGIC_CODE_REQUESTING:
    case SIGNUP_REQUESTING:
      return {
        ...state,
        requesting: true,
        successful: false,
        error: "",
        errors: initialState.errors,
      };

    case GET_CLIENT_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case GET_CLIENT_SUCCESS:
      return {
        ...state,
        requesting: false,
        userClient: action.payload,
      };

    case GET_CLIENT_ERROR:
      return {
        ...state,
        requesting: false,
      };

    case SIGNUP_ONBOARDING_END_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case SIGNUP_SUCCESS:
      return {
        ...state,
        requesting: false,
        successful: true,
      };

    case CHECK_MAGIC_CODE_SUCCESS: {
      const { signupPolicy, name } = action.payload.clientId;
      return {
        ...state,
        clientName: name,
        signupPolicy,
        requesting: false,
      };
    }

    case CHECK_MAGIC_CODE_ERROR:
      return {
        ...state,
        requesting: false,
        error: action.payload,
      };

    case SIGNUP_ERROR: {
      const errors = { ...initialState.errors };
      errors.name = action.error.name;
      // errors[action.error.field] = action.error.field;
      return {
        ...state,
        messages: [],
        requesting: false,
        successful: false,
        errors,
      };
    }
    case SIGNUP_INPUT_CHANGE: {
      return {
        ...state,
        ...action.payload,
        errors: initialState.errors,
      };
    }

    case SIGNUP_PROGRESS_CHANGE: {
      return {
        ...state,
        progress: state.progress + action.payload,
      };
    }

    case SIGNUP_PROGRESS_CHANGE_RATIO: {
      return {
        ...state,
        progressRatio: 1 / 20,
      };
    }

    case SIGNUP_STATS_CHANGE: {
      return {
        ...state,
        stats: { ...state.stats, ...action.payload },
      };
    }

    case SIGNUP_CHOICE_ADD: {
      // const index = state.choiceAvailable.findIndex(el => el === action.payload);
      return {
        ...state,
        // choiceAvailable: [
        //   ...state.choiceAvailable.slice(0, index),
        //   ...state.choiceAvailable.slice(index + 1)
        // ],
        choice: [...state.choice, action.payload],
      };
    }

    case SIGNUP_CHOICE_REMOVE: {
      const index = state.choice.findIndex(el => el === action.payload);
      return {
        ...state,
        choice: [
          ...state.choice.slice(0, index),
          ...state.choice.slice(index + 1),
        ],
        // choiceAvailable: [...state.choiceAvailable, action.payload]
      };
    }

    case SIGNUP_CLICK_TOPIC: {
      const userTopicChoices = state.userTopicChoices.filter(
        el => el.value !== action.payload.value,
      );
      if (userTopicChoices.length === state.userTopicChoices.length) {
        userTopicChoices.push(action.payload);
      }
      return {
        ...state,
        userTopicChoices,
      };
    }

    case SIGNUP_SURVEY_SET_STATS: {
      const stats = { ...state.stats };
      const userTopicChoices = [...state.userTopicChoices];

      return {
        ...state,
        stats,
        userTopicChoices,
      };
    }

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
